import { updateGroup } from '@wix/ambassador-social-groups-v2-group/http';
import { ContentType } from '@wix/ambassador-social-groups-v2-group/types';
import { chunk as getChunks } from 'lodash';
import { fetchGroups } from '../new-infra-fetchers/fetch-groups';
import { buildGroupsBulkUpdatePayload } from './build-payloads/bulk-update-groups-alt-text-payload-builder';
const BULK_LIMIT = 100;
export const updateGroupsAltText = async (httpClient, errorHandler, altTextData) => {
  const {
    withErrorHandler,
    getResolvedError
  } = errorHandler;
  const entityIdsList = altTextData.map(item => item.entityId).filter(entityId => entityId !== undefined);
  try {
    const groups = await fetchGroups(httpClient, errorHandler, entityIdsList);
    const groupsMap = new Map(groups.map(group => [group.id, group]));
    const allFailedElements = [];
    const chunks = getChunks(altTextData, BULK_LIMIT);
    const results = [];
    for (const chunk of chunks) {
      const payload = buildGroupsBulkUpdatePayload(chunk, groupsMap);
      if (payload.length === 0) {
        results.push({
          success: false
        });
        allFailedElements.push(...chunk);
        continue;
      }
      const chunkPromises = payload.map(async group => {
        const {
          data: {
            group: updatedGroup
          }
        } = await withErrorHandler(async () => httpClient.request(updateGroup({
          contentType: ContentType.RICH_CONTENT,
          group
        })), {
          errorCodesMap: {
            applicationError: {
              INVALID_GROUP_STATUS_TRANSITION: false,
              INVALID_SLUG_FORMAT: false,
              SLUG_ALREADY_IN_USE: false
            }
          }
        });
        return {
          success: !!updatedGroup
        };
      });
      const chunkResults = await Promise.all(chunkPromises);
      const success = chunkResults.every(result => result.success);
      if (!success) {
        const failedIndexes = (chunkResults ?? []).map((_item, index) => index).filter(index => index !== undefined);
        const failedElementsChunk = chunk.filter((_, index) => failedIndexes.includes(index));
        allFailedElements.push(...failedElementsChunk);
      }
      results.push({
        success
      });
    }
    const overallSuccess = results.every(result => result.success);
    return {
      failedElements: allFailedElements,
      success: overallSuccess
    };
  } catch (error) {
    return {
      errorMessage: getResolvedError(error).message,
      failedElements: altTextData,
      success: false
    };
  }
};
//# sourceMappingURL=update-groups-alt-text.js.map